import { render, staticRenderFns } from "./invoiceView.vue?vue&type=template&id=2cdb0956&"
import script from "./invoiceView.vue?vue&type=script&lang=js&"
export * from "./invoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports